import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { TEntityType } from '@/components/entity-detail/types/EntityType.types';

export type EntityDetail = {
    entityId: string;
    type: TEntityType;
    identifier: string;
    data?: {
        loading: boolean;
        error?: string;
        data?: any;
    };
};

interface EntityDetailState {
    [identifier: string]: EntityDetail;
}

const initialState: EntityDetailState = {};

export const entityDetailSlice = createSlice({
    name: 'entityDetail',
    initialState,
    reducers: {
        showEntityDetailAction: (
            state,
            action: PayloadAction<EntityDetail>
        ) => {
            state[action.payload.identifier] = action.payload;

            if (!action.payload.data) {
                state[action.payload.identifier].data = {
                    loading: true,
                };
            }
        },

        setEntityDetailAction: (
            state,
            action: PayloadAction<Omit<EntityDetail, 'entityId' | 'type'>>
        ) => {
            if (state[action.payload.identifier]) {
                state[action.payload.identifier].data = action.payload.data;
            }
        },

        removeEntityDetailAction: (state, action: PayloadAction<string>) => {
            delete state[action.payload];
        },
    },
});

export const {
    setEntityDetailAction,
    removeEntityDetailAction,
    showEntityDetailAction,
} = entityDetailSlice.actions;

export default entityDetailSlice.reducer;
